<lib-modal-layout [title]="'Prior Work Exclusion'" [subtitle]="''">
  <h2 class="app text-center m-4">{{ data.subtitle }}</h2>
  <h4 class="app text-center m-4">Request Submitted</h4>
  <form [formGroup]="form">
    <lib-form-dropdown class="width-inherit" formControlName="removePriorWork"
      label="Remove Exclusion for Prior Completed or Abandoned Work?"
      [manualOptions]="[{value: true, name:'Yes'} , {value:false, name:'No'}]">
    </lib-form-dropdown>

    <lib-custom-date-picker
      class="width-inherit" 
      formControlName="priorWorksEffectiveDate"
      label="Prior Works Exclusion Retro Date">
    </lib-custom-date-picker>

    <div class="mt-4">
      <lib-custom-date-picker
        class="width-inherit"
        formControlName="issuedEffectiveDate"
        label="Effective Date">
      </lib-custom-date-picker>
    </div>

    @if (!data.retailAgentId) {
      <h4 class="mt-[35px]">Agency/Producer Information</h4>
      <p class="py-3">Please provide the following agency and producer information.</p>

      <div class="w-full flex gap-[35px]">
        <lib-form-text class="w-1/2" label="Agency Name" formControlName="agencyName" maxlength="150"></lib-form-text>
        <lib-form-text class="w-1/2" label="Producer Name" formControlName="producerName" maxlength="150"></lib-form-text>
      </div>

      <div class="w-full flex gap-[35px]">
        <lib-form-text class="w-1/2" label="Primary Agency Address" formControlName="agencyAddress1" maxlength="50"></lib-form-text>
        <lib-form-text class="w-1/2" label="Suite" formControlName="agencyAddress2" maxlength="50"></lib-form-text>
      </div>

      <div class="w-full flex gap-[35px]">
        <lib-form-text class="w-1/2" label="City" formControlName="agencyCity" maxlength="64"></lib-form-text>
        <div class="flex w-1/2 gap-[35px]">
          <lib-form-dropdown class="w-1/2" label="State" [options]="lookupStore.states()!" [placeholder]="'Select State'" formControlName="agencyStateCode"></lib-form-dropdown>
          <lib-form-text class="w-1/2" label="Zip Code" formControlName="agencyZipCode" mask="99999" maxlength="10"></lib-form-text>
        </div>
      </div>
    }
  </form>

  <div class="text-center my-5">
    <lib-button
      [cssType]="'btn-primary'"
      text="Issue Policy"
      [type]="'button'"
      (click)="onSubmit()"
      [disabled]="!form.valid"
      [icon]="'rightarrow'"
    >
    </lib-button>
  </div>
</lib-modal-layout>